export default "__VITE_ASSET__UrEza8c8__"